// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"f8caf435","703":"39735ef1","807":"6af81185","819":"433f39d1"}[chunkId] + ".chunk.css";
};